import {
  cancelDestructRequest,
  destructRequestCommentDelete,
  destructRequestCommentInsert,
  getAllDestructionStatusTypes,
  getAllPersonnels,
  getCustomerMdrDetails,
  getDesReqComment,
  getServiceLocation,
  getServiceLocationByCustomerTrigger,
  postNewDestructRequest,
  postUpdateDestructRequest,
  verifyPersonnelPermissionStatus
} from "services/common";
import { TAG_TYPES } from "utils/constants";
import { dataDogErrorLog, getAuthenticatedUserBranch, handleRefId } from "utils/helpers";
import { baseApi } from "../baseApi";

export const requestDetailDeliveryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    //get service location by customer
    getServiceLocation: builder.query({
      queryFn: async (props) => {
        try {
          const response = await getServiceLocation(props);
          // console.log(response, "response==");
          return {
            data: response?.map(({ number, customerId }) => ({
              label: number,
              value: customerId
            }))
          };
        } catch (err) {
          return { error: err };
        }
      },
      providesTags: (result, error, arg) =>
        result
          ? [{ type: TAG_TYPES.authorizationPersonnel, id: arg.personnelId }]
          : [TAG_TYPES.authorizationPersonnel]
    }),
    //get service location by customer
    getServiceLocationByCustomerTrigger: builder.mutation({
      queryFn: async (props) => {
        try {
          const response = await getServiceLocationByCustomerTrigger(props);
          return {
            data: response?.map(({ customer_id, number }) => ({
              label: number?.trim() ? number?.trim() : "",
              value: customer_id ? customer_id : ""
            }))
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(
            message,
            "",
            { error: err },
            refId
          );
          return { error: message };
        }
      },
      providesTags: (result, error, arg) =>
        result
          ? [{ type: TAG_TYPES.authorizationPersonnel, id: arg.personnelId }]
          : [TAG_TYPES.authorizationPersonnel]
    }),
    //get customer media destruction details
    getCustomerMdrDetails: builder.query({
      queryFn: async (props) => {
        try {
          const response = await getCustomerMdrDetails(props);
          return {
            data: response?.map((obj) => obj)
          };
        } catch (err) {
          return { error: err };
        }
      },
      providesTags: (result, error, arg) =>
        result
          ? [{ type: TAG_TYPES.customer, id: arg.customerId }]
          : [TAG_TYPES.customer]
    }),
    //get all personals
    getAllPersonnels: builder.query({
      queryFn: async (props) => {
        try {
          const response = await getAllPersonnels(props);
          return {
            data: response?.map(({ name, personnelId, customerId }) => ({
              label: name,
              value: personnelId,
              customerId: customerId
            }))
          };
        } catch (err) {
          return { error: err };
        }
      },
      providesTags: (result, error, arg) =>
        result
          ? [{ type: TAG_TYPES.authorizationPersonnel }]
          : [TAG_TYPES.authorizationPersonnel]
    }),
    //get all destruction status types
    getAllDestructionStatusTypes: builder.query({
      queryFn: async (props) => {
        try {
          const response = await getAllDestructionStatusTypes(props);

          return {
            data: response?.map(({ descr, destruct_request_status_id }) => ({
              label: descr ? descr : "",
              value: destruct_request_status_id
                ? destruct_request_status_id
                : ""
            }))
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(
            message,
            "",
            { error: err },
            refId
          );
          return { error: message };
        }
      },
      providesTags: [TAG_TYPES.requestStatus]
    }),
    //get destruction request comment
    getDesReqComment: builder.mutation({
      queryFn: async (props) => {
        try {
          const response = await getDesReqComment(props);
          return {
            data: response
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(
            message,
            `${process.env.REACT_APP_CF_URL_MODULE_REQUEST}/destruction/returndestructrequestcomments`,
            {
              main_district_id: getAuthenticatedUserBranch(),
              destruct_request_id: props?.destruct_request_id,
              destruct_request_status_id: props?.destruct_request_status_id,
              error: err
            },
            refId
          );
          return { error: message };
        }
      },
      providesTags: [TAG_TYPES.desReqComment]
    }),
    //verify personnel permission
    verifyPersonnelPermissionStatus: builder.mutation({
      queryFn: async (props) => {
        try {
          const response = await verifyPersonnelPermissionStatus(props);
          return {
            data: response
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(
            message,
            "",
            { error: err },
            refId
          );
          return { error: message };
        }
      },
      providesTags: [TAG_TYPES.verifyPermission]
    }),
    //post destruction request
    postNewDestructRequest: builder.mutation({
      queryFn: async (props) => {
        try {
          const response = await postNewDestructRequest(props);
          return {
            data: response
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(
            message,
            `${process.env.REACT_APP_CF_URL_MODULE_REQUEST}/destruction/createnewmediadestructionrequest`,
            {
              main_district_id: getAuthenticatedUserBranch(),
              function: "sb_fs_destruct_request_i_sp",
              customer_id: props?.customer_id,
              requested_personnel_id: props?.requested_personnel_id,
              approx_bulk_count: "",
              pickup_instruction: props?.pickup_instruction,
              volser_list: "",
              im_comment: "",
              business_email_addr: props?.business_email_addr,
              logged_in_employee_id: props?.logged_in_employee_id,
              destruct_request_type_id: props?.destruct_request_type_id,
              preferred_service_date: props?.preferred_service_date,
              preferred_service_location_customer_id:
                props?.preferred_service_location_customer_id,
              tracking_number: "",
              auth_bypass_reason: props?.auth_bypass_reason,
              error: err
            },
            refId
          );
          return { error: message };
        }
      },
      providesTags: [TAG_TYPES.destructRequestSave]
    }),
    //update destruction request
    postUpdateDestructRequest: builder.mutation({
      queryFn: async (props) => {
        try {
          const response = await postUpdateDestructRequest(props);
          return {
            data: response
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(
            message,
            `${process.env.REACT_APP_CF_URL_MODULE_REQUEST}/destruction/updatemediadestruction`,
            {
              main_district_id: getAuthenticatedUserBranch(),
              function: "sb_fs_destruct_request_u2_sp",
              service_result_id: props?.service_result_id,
              system_id: props?.system_id,
              destruct_request_id: props?.destruct_request_id,
              destruct_req_timestamp: props?.destruct_req_timestamp,
              day_of_week_code: props?.day_of_week_code,
              tracking_number: props?.tracking_number,
              bulk_weight: props?.bulk_weight,
              destruct_request_type_id: props?.destruct_request_type_id,
              to_destruct_request_status_id: props?.to_destruct_request_status_id,
              logged_in_employee_id: props?.logged_in_employee_id,
              unit_of_measure_id: props?.unit_of_measure_id,
              approx_bulk_quantity: props?.approx_bulk_quantity,
              im_comment: props?.im_comment,
              actual_quantity: props?.actual_quantity,
              service_date: props?.service_date,
              customer_id_service_location: props?.customer_id_service_location,
              error: err
            },
            refId
          );
          return { error: message };
        }
      },
      providesTags: [TAG_TYPES.desSave]
    }),
    //cancel destruction request
    cancelDestructRequest: builder.mutation({
      queryFn: async (props) => {
        try {
          const response = await cancelDestructRequest(props);
          return {
            data: response
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(
            message,
            `${process.env.REACT_APP_CF_URL_MODULE_REQUEST}/destruction/canceldestructrequest`,
            {
              main_district_id: getAuthenticatedUserBranch(),
              destruct_request_id: props?.destruct_request_id,
              cancel_personnel_id: props?.cancel_personnel_id,
              cancel_employee_id: props?.cancel_employee_id,
              destruct_cancel_reason_id: props?.destruct_cancel_reason_id,
              last_mod_user: props?.last_mod_user,
              error: err
            },
            refId
          );
          return { error: message };
        }
      },
      providesTags: [TAG_TYPES.desSave]
    }),
    //destruct request comment insert
    destructRequestCommentInsert: builder.mutation({
      queryFn: async (props) => {
        try {
          const response = await destructRequestCommentInsert(props);
          return {
            data: response
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(
            message,
            `${process.env.REACT_APP_CF_URL_MODULE_REQUEST}/destruction/destructrequestcommentinsert`,
            {
              main_district_id: getAuthenticatedUserBranch(),
              function: "sb_fs_destruct_request_comment_i_sp",
              destruct_request_id: props?.destruct_request_id,
              destruct_request_comment_type_id: props?.destruct_request_comment_type_id,
              destruct_request_status_id: props?.destruct_request_status_id,
              comment_text: props?.comment_text,
              last_mod_date: props?.last_mod_date,
              last_mod_user: props?.last_mod_user,
              error: err
            },
            refId
          );
          return { error: message };
        }
      },
      providesTags: [TAG_TYPES.desSave]
    }),
    //destruct request comment delete
    destructRequestCommentDelete: builder.mutation({
      queryFn: async (props) => {
        try {
          const response = await destructRequestCommentDelete(props);
          return {
            data: response
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(
            message,
            `${process.env.REACT_APP_CF_URL_MODULE_REQUEST}/destruction/destructrequestcommentdelete`,
            {
              main_district_id: getAuthenticatedUserBranch(),
              function: "sb_fs_destruct_request_comment_d_sp",
              destruct_request_id: props?.destruct_request_id,
              destruct_request_comment_type_id:
                props?.destruct_request_comment_type_id,
              destruct_request_status_id: props?.destruct_request_status_id,
              error: err
            },
            refId
          );
          return { error: message };
        }
      },
      providesTags: [TAG_TYPES.desSave]
    })
  })
});
